<ng-container *ngIf="!this.registrationStepService.isLoading">
  <div class="d-flex justify-content-end registration-navigation-button">
    <!-- Previous Button -->
    <button
      class="btn btn-previous-step mb-0"
      (click)="goToPreviousStep()"
      [disabled]="isFirstTimeRegistration && !hasPreviousStep"
      [ngClass]="{ 'single-back-btn': hideNextBtn }"
    >
      <ng-container *ngIf="!backLabel; else backLabelInput">
        <ng-container *ngIf="hasPreviousStep; else noPreviousStep"
          >{{ 'fgbcl.registration.navigation.back.btn.text' | translate: { fgbdefault: 'Back' } }}
        </ng-container>
        <ng-template #noPreviousStep
          >{{ 'fgbcl.registration.navigation.cancel.btn.text' | translate: { fgbdefault: 'Cancel' } }}
        </ng-template>
      </ng-container>
      <ng-template #backLabelInput>{{ backLabel }}</ng-template>
    </button>

    <!-- Next Button -->
    <button
      *ngIf="!hideNextBtn"
      class="btn btn-next-step mb-0"
      (click)="nextButtonClicked.emit()"
      [disabled]="nextButtonDisabled"
    >
      <ng-container *ngIf="!nextLabel; else nextLabelInput">
        {{ 'fgbcl.registration.navigation.next.btn.text' | translate: { fgbdefault: 'Next' } }}
      </ng-container>
      <ng-template #nextLabelInput>{{ nextLabel }}</ng-template>
    </button>
  </div>
</ng-container>
